module.exports = __webpack_public_path__ + "assets/media/dizzy_robot.0599dc9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dizzy_robot.svg
// module id = 2718
// module chunks = 0